<template>
	<div class="homePage">
    <div class=" layout shadow">
   <div class="hmylogin">
  
    <div class="hmy1">
      <div class="hmytext">
       会员登录</div>
      
     
     
      <div class="logocenttinput1">
    
        <input placeholder="请输入手机号码"  v-model="mobile" name="mobile2" class="logocenttinputa">
   
         <div class="logoinputA">
                       <input placeholder="输入短信验证码" v-model="code" name="dxyzh" class="logocenttinputa">

					   <input type="button" :disabled='disabled' :value="yanzhengma"  @click="sendSms()" id="send" class="lyzm">
					   
                       </div>
    
        <button class="logoinputB" @click="getreqDengl()">登录</button>
        <div class="hmyf1" style="padding-top:30px">新用户 ? <router-link to="/index/register">点击注册</router-link></div>
        
      </div>
      
    </div>
    
    <div class="hmy2">
       <p class="hmyf4">如果您是新用户，请先注册成为我们的会员！只有会员才能对招标内容进行报价！</p>
     
       <div class="hsign_btn"><router-link to="/index/register">会员注册</router-link></div>
       <div class="hreturn">
		<router-link to="/">查看更多招标信息</router-link>
	</div>
    </div>
    
    
    </div>
</div>

<div class="xiugaidizhi" v-if="xiugaist == true">
                <div class="dizhi">
                  <img id="img"  :src="pic" style="margin:0 auto; width:100%">
                  <div class="secad">
                    <input v-model="kcaptcha" placeholder="请输入验证码" />
                  </div>
                  <div class="xinzeng">
                    <div class="xinzeng1" @click="sms">
                      确定
                    </div>
                    <div class="xinzeng2" @click="quxiao">
                      取消
                    </div>
                  </div>
                </div>

              </div>
			
	</div>
</template>

<script>
	export default {
		name: "login",
		components: {},
		data() {
			return {
				mobile: '',
				code: '',
				disabled: false,
				yanzhengma: '获取验证码',
				pic: '',
				kcaptcha: '',
				key: '',
				duanxin: '',
				xiugaist: false,
			};
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			async sendSms() {
				var that = this
				//验证手机
				var m = that.mobile.replace(/(^\s*)|(\s*$)/g, "");
				if (m == '' || !m) {
          			this.$message.error('错了哦，手机号不能为空');
					return false;
				}
				if (that.verifymobile(m) == false) {
         			this.$message.error('错了哦，手机号格式错误');
					return false;
				}
       			 that.captcha()
			},
     		 //获取图片验证码
			async captcha() {
				var that = this
				let res = await that.req.reqyanzheng({})
				
				if (res.status == 200) {
        			console.log(res)
					//获取验证码成功	
					that.pic = res.data.base64
					that.key = res.data.key
					that.xiugaist = true
				}
			},


		//点击确认后发送验证码到服务器验证是否正确,获取短信验证码
		async sms() {
				var that = this
				if (that.kcaptcha == '') {
         			this.$message.error('请输入验证码');
					return
				}
        		var form = {
					mobile: that.mobile,
					captchaCode: that.kcaptcha,
					captchaKey: that.key,
				};

				let res = await this.req.reqSendsms({
					form
				})
				console.log('获取手机验证码')
				console.log(res)
				if (res.status == 200) {
					this.xiugaist = false
					var wait = 60;
					that.disabled = true
					var time_line = setInterval(function() {
						that.yanzhengma = (--wait) + "秒后重发"
						if (wait == -1) {
							that.yanzhengma = "重新获取"
							that.disabled = false
							clearInterval(time_line);
						}
					}, 1000);
				} else {
         			 this.$message.error(res.message);
				}
			},


			 //手机号验证
			 verifymobile(mobile) {
				var phone = /^13[0-9]{1}[0-9]{8}$|15[0-9]{1}[0-9]{8}$|18[0-9]{1}[0-9]{8}$|17[0-9]{9}$/;
				if (!phone.test(mobile)) {
					return false;
				}
			},
			//取消弹出框
			quxiao() {
				this.xiugaist = false
			},


			//登录接口
			async getreqDengl() {
				var that = this
				
				let mobile = that.mobile.replace(/(^\s*)|(\s*$)/g, "");
				let code = that.code.replace(/(^\s*)|(\s*$)/g, "");
			
				if (mobile == '' || !mobile) {
         			this.$message.error('手机号不能为空');
					return
				}
       			if (that.verifymobile(mobile) == false) {
         			 this.$message.error('手机号格式错误');
					return false;
				}	
				if (code == '' || !code) {
         			this.$message.error('请输入验证码');
					return
				}
       				
        		let form = {
					mobile: that.mobile,
					smsCode: that.code,
				};	
        		console.log(form)				
				let res = await this.req.reqDengl({
					form
				})
				console.log(res)
				if (res.status == 200) {
					//如果登录成功
					//  this.$cookies.set("token", res.data.token);
					 localStorage.setItem("tb_token", res.data.token);
					 localStorage.setItem("tb_user_name", this.mobile);

					 this.$store.dispatch('login',this.mobile);

					this.$message({
						message: '恭喜你，登录成功',
						type: 'success'
					});
					setTimeout(function(){
						that.$router.push({ name: 'mybaojia'})
						// that.$router.push({ name: 'mybaojia'}).then(() => {
						// 	window.location.reload(); // 整页刷新
						// });
					},1000)	
				} else {
					this.$confirm('登录失败！'+res.message, '提示', {
						confirmButtonText: '确定',
						type: 'warning'				
					});
				}
			},



			//获取个人信息
			// async getRequser() {
			// 	var that = this
			// 	let res = await this.req.requser({})
			// 	console.log(res)
			// 	if (res.status == 200) {
			// 	} else {
					
			// 	}
			// },





			
		},
	};
</script>

<style lang="less" scoped>
	.xiugaidizhi {
		width: 100%;
		height: 100vh;
		position: fixed;
		z-index: 10;
		left: 0;
		top: 0;
		box-sizing: border-box;
		padding: 25px;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		align-items: center;

		.dizhi {
			width: 300px;
			background-color: #fff;
			box-sizing: border-box;
			padding: 25px;
			border-radius: 8px;margin: 0 auto;text-align: center;

			.secad1 {
				color: #000;
				font-size: 16px;
				font-weight: bold;
				padding-bottom: 8px;
			}

			.secad {
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;
				color: #858585;
				font-size: 14px;
				line-height: 50px;
				height: 50px;
				border-bottom: 1px solid #f9f9f9;
			}

			.secad input {
				width: 100%;
				font-size: 14px;
				border: 1px solid #e8e8e8;
  padding: 10px 15px;
			}

			.xinzeng {
				padding: 25px 0 10px 0;
				width: 100%;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.xinzeng1 {
				height: 40px;
				width: 45%;
				line-height: 40px;
				background: linear-gradient(to right, #fd0402, #fe7879);
				text-align: center;
				color: #fff;
				font-size: 16px;
				border-radius: 5px;
			}

			.xinzeng2 {
				height: 40px;
				width: 45%;
				line-height: 40px;
				background-color: #929292;
				text-align: center;
				color: #fff;
				font-size: 16px;
				border-radius: 5px;
			}

		}
	}
	
</style>
